import { render, staticRenderFns } from "./ApplicationReportsView.vue?vue&type=template&id=0b328128&"
import script from "./ApplicationReportsView.vue?vue&type=script&lang=js&"
export * from "./ApplicationReportsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports